import { EventEmitter, ViewContainerRef } from '@angular/core';
import { FilterMetadata } from '@irian-ro/abstract-resource';
import { DateRangeComponent } from '@irian-ro/shared-components-module';
import { FilterComponentFactory } from '@irian-ro/table-column-filter';
import { constants } from '@well/infra/constants';

export interface InputOptions {
  props?: {
    config?: {
      minimumDay?: Date;
      maximumDay?: Date;
      datePattern?: string;
      canHaveSuffix?: boolean;
    }
    value?: {
      startDate: string;
      endDate: string;
    };
  };
  filterMatchMode?: string;
  filterChangeEvent?: EventEmitter<FilterMetadata>;
}

export const dateRangeInputFactory: FilterComponentFactory<DateRangeComponent> = {
  createInstance: (container: ViewContainerRef) => {
    return container.createComponent<DateRangeComponent>(DateRangeComponent).instance;
  },

  bindProps: (instance: DateRangeComponent, options?: InputOptions) => {
    instance.startDate = options?.props?.value?.startDate ? new Date(options?.props?.value.startDate) : null;
    instance.endDate = options?.props?.value?.endDate ? new Date(options?.props?.value.endDate) : null;

    if (options?.props?.config?.minimumDay) {
      instance.minimumDay = options?.props?.config?.minimumDay
    }
    if (options?.props?.config?.maximumDay) {
      instance.maximumDay = options?.props?.config?.maximumDay
    }

    instance.suffix = options?.props?.config?.canHaveSuffix ? 'Z' : '';
    instance.datePattern = options?.props?.config?.datePattern ? options?.props?.config?.datePattern : constants.defaultDateAndTimePattern;
    instance.class = 'd-flex flex-column';
  },

  subscribeToChanges: (instance: DateRangeComponent, options?: InputOptions) => {
    instance.dateSelected.subscribe((value: { startDate: string; endDate: string }) => {
      if (options?.filterChangeEvent) {
        options?.filterChangeEvent.emit({
          value: value,
          matchMode: options?.filterMatchMode,
        });
      }
    });
  },
};
